<div mat-dialog-content>
  <h3 mat-dialog-title style="margin-bottom: 0px;">{{title}}</h3>
  <div [innerHtml]="message"></div>
</div>
<div mat-dialog-actions align="center">
  <button color="accent" mat-flat-button (click)="close()">
    Ok
  </button>
</div>
